
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 535.4 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M518.673 478.518a48.521 48.521 0 01-27.774-7.864 111.598 111.598 0 00-11.043-5.689 101.225 101.225 0 005.354-9.202l48.354-96.875a16.731 16.731 0 00-14.89-24.26H351.358V16.73A16.731 16.731 0 00334.628 0a234.24 234.24 0 00-234.24 234.24v33.462a16.731 16.731 0 0016.732 16.732 66.926 66.926 0 0164.583 50.194H33.463a16.731 16.731 0 00-16.732 16.731v66.926a104.906 104.906 0 008.7 40.49l-8.7-.335a16.731 16.731 0 000 33.463 47.852 47.852 0 0127.607 7.864 79.474 79.474 0 0044.004 12.214 79.641 79.641 0 0044.17-12.214 47.517 47.517 0 0127.607-7.864 47.852 47.852 0 0127.607 7.864 79.474 79.474 0 0044.004 12.214 79.474 79.474 0 0044.003-12.214 47.852 47.852 0 0127.607-7.864 48.521 48.521 0 0127.774 7.864 85.33 85.33 0 0088.007 0 53.039 53.039 0 0155.549 0 79.474 79.474 0 0044.003 12.214 16.731 16.731 0 000-33.463zM133.851 252.309v-18.07A200.777 200.777 0 01317.896 33.463v301.165H216.17a100.388 100.388 0 00-82.319-82.319zm269.04 218.345a53.039 53.039 0 01-55.547 0 78.47 78.47 0 00-44.004-12.214 79.474 79.474 0 00-44.003 12.214 47.852 47.852 0 01-27.607 7.864 47.852 47.852 0 01-27.607-7.864 79.474 79.474 0 00-44.004-12.214 79.474 79.474 0 00-44.003 12.214 48.521 48.521 0 01-27.774 7.864 54.042 54.042 0 01-7.697 0 81.147 81.147 0 01-30.45-60.233V368.09h441.373l-36.307 72.614a50.194 50.194 0 01-15.56 18.07 78.303 78.303 0 00-36.81 11.88z","data-name":"kapal layar"}})])
          )
        }
      }
    